import React from 'react';
import { Flex } from 'antd';

import phoneWhite from '../../../../assets/images/AiphoneWhite.svg';
import avatar from '../../../../assets/images/pocavatar.svg';

export type CallTranscriptMessage = {
  sender?: string;
  text: string;
};

type Props = {
  transcript?: CallTranscriptMessage[];
  agentName?: string;
  contactName?: string;
};

const CallPreview: React.FC<Props> = ({
  transcript = [],
  agentName = 'AI assistant',
  contactName = 'Rob',
}) => {
  const seen = { agent: false, user: false };

  return (
    <div className='chat-scroll-container'>
      {transcript?.map((msg, i) => {
        const senderType =
          msg.sender?.toLowerCase() === 'agent' ? 'agent' : 'user';

        const outgoing = senderType === 'agent';
        const shouldShowName = !seen[senderType];
        if (shouldShowName) seen[senderType] = true;

        const senderName = outgoing ? agentName : contactName;

        return (
          <div key={i}>
            <Flex justify={outgoing ? 'flex-end' : 'flex-start'}>
              <div
                className={`chat-bubble ${outgoing ? 'outgoing' : 'incoming'}`}
              >
                {msg.text}

                {outgoing ? (
                  <img
                    alt='call'
                    src={phoneWhite}
                    className='chat-avatar outgoing'
                  />
                ) : (
                  <img
                    alt='contact'
                    src={avatar}
                    className='chat-avatar incoming'
                  />
                )}
              </div>
            </Flex>

            {shouldShowName && (
              <Flex
                justify={outgoing ? 'flex-end' : 'flex-start'}
                className='chat-sender'
              >
                <div
                  style={{ margin: '0px 50px' }}
                  className='chat-sender-name'
                >
                  {senderName}
                </div>
              </Flex>
            )}
          </div>
        );
      })}

      {(transcript?.length ?? 0) === 0 && (
        <p style={{ margin: 0 }}>No transcript available</p>
      )}
    </div>
  );
};

export default CallPreview;
